// Angular
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
// RxJS
import { Observable, Subject } from 'rxjs';
// Auth
import { AuthService } from '../../../../core/auth/_services/auth.service';
import { AuthNoticeService } from '../../../../core/auth/auth-notice/auth-notice.service';
import packageInfo from '../../../../../../package.json';
const version = packageInfo.version;

@Component({
	selector: 'kt-login',
	templateUrl: './login.component.html',
	encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit, OnDestroy {
	// Public params
	loading = false;
	isLoggedIn$: Observable<boolean>;
	errors: any = [];
	version;
	private unsubscribe: Subject<any>;

	/**
	 * Component constructor
	 *
	 * @param auth: AuthService
	 * @param authNoticeService: AuthNoticeService
	 */
	constructor(
		private auth: AuthService,
		private authNoticeService: AuthNoticeService
	) {
		this.unsubscribe = new Subject();
		this.version = version;
	}

	ngOnInit(): void {
	}

	ngOnDestroy(): void {
		this.authNoticeService.setNotice(null);
		this.unsubscribe.next(void 0);
		this.unsubscribe.complete();
		this.loading = false;
	}

	submit() {
		this.loading = true;

		this.auth.startAuthentication();
	}
}
